export default __webpack_public_path__ + "static/media/userflow.2181e145.jpg";